<template>
  <div :class="$style[classes]">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" ref="table" isAddPageToRouter
    :isOutside="isOutside" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
      <template>
         <div v-if="customerStatisticsData" class="table-tip-text-class">
      当前页面老用户奖励金额小计：<span class="amount-class">{{customerStatisticsData.oldCustomerOfMoney}}元</span>；
      新用户奖励金额小计：<span class="amount-class">{{customerStatisticsData.newCustomerOfMoney}}元</span>；
      总计：<span class="amount-class">{{customerStatisticsData.allCustomerOfMoney}}</span>元
      </div>
        <wt-table :labels="tableLabels"  ref="tables" :list="tableData" @select="select" :is-select="isShowSelect"
        @select-all="selectAll">
        <template slot="before">
          <el-table-column label="奖励审核流水号" min-width="100">
            <template slot-scope="scope">
              {{scope.row.number}}
            </template>
          </el-table-column>
          <el-table-column label="活动类型" min-width="100">
            <template slot-scope="scope">
              {{scope.row.businessDescription}}
            </template>
          </el-table-column>
          <el-table-column label="所属分公司" min-width="150">
            <template slot-scope="scope">
              {{scope.row.extendInformation&&scope.row.extendInformation.cpsOrgName}}
            </template>
          </el-table-column>
          <el-table-column label="申请ID" min-width="100">
            <template slot-scope="scope">
              {{scope.row.extendInformation.customerBringNew.serialNumber}}
            </template>
          </el-table-column>
          <el-table-column label="申请日期" min-width="100">
            <template slot-scope="scope">
              {{scope.row.extendInformation&&scope.row.extendInformation.achieve_date}}
            </template>
          </el-table-column>
          <el-table-column label="申请类型">
            <template slot-scope="scope">
              {{scope.row.extendInformation&&scope.row.extendInformation.user_type}}
            </template>
          </el-table-column>
          <el-table-column :label="(businessType==='CUSTOMER_BRING_NEW_QJK'||!businessType)?'下单时新用户是否绑定CPS合同':'是否绑定CPS'">
            <template slot-scope="scope">
              {{scope.row.cpsBind?'是':'否'}}
            </template>
          </el-table-column>
          <el-table-column label="老用户手机号" min-width="120">
            <template slot-scope="scope">
            <router-link v-if="scope.row.extendInformation&&scope.row.extendInformation.customerBringNew&&
              scope.row.extendInformation.customerBringNew.oldCustomer&&scope.row.extendInformation.customerBringNew.oldCustomer.userMobile"
              :class="$style['get-customer-detail']" :to="`/all-customer/customer-detail/${scope.row.extendInformation.customerBringNew.oldCustomer.userId}?state=basic-message`">
              {{scope.row.extendInformation.customerBringNew.oldCustomer.userMobile}}
            </router-link>
            <template v-else>--</template>
            </template>
          </el-table-column>
          <!-- <el-table-column label="老用户CPS合同姓名" >
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfOld&&scope.row.contractInformationOfOld.length">
              <div v-for="(item,index) in scope.row.contractInformationOfOld" :key="index">
                <template>{{item.motherName?item.motherName:'--'}}</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="老用户CPS合同号"  min-width="180">
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfOld&&scope.row.contractInformationOfOld.length">
              <div v-for="(item,index) in scope.row.contractInformationOfOld" :key="index">
                <template >{{item.contractCode?item.contractCode:"--"}}</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="老用户CPS合同地区">
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfOld&&scope.row.contractInformationOfOld.length">
              <div v-for="(item,index) in scope.row.contractInformationOfOld" :key="index">
                <template>{{item.cpsRegion?item.cpsRegion:"--"}}</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="老用户CPS产品名称" min-width="180">
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfOld&&scope.row.contractInformationOfOld.length">
              <div v-for="(item,index) in scope.row.contractInformationOfOld" :key="index" :class="index+1<scope.row.contractInformationOfOld.length?'production-name-code-buttom':null" >
                <template v-if="item.productInformation.length">
                  <div v-for="(etem,i) in item.productInformation" :key="i">
                    {{etem.name?etem.name:"--"}}

                  </div>
                </template>
                <template v-else>--</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column> -->

          <!-- <el-table-column label="老用户CPS业务员">
            <template slot-scope="scope">
            <template v-if="scope.row.contractInformationOfOld&&scope.row.contractInformationOfOld.length">
              <div v-for="(item,index) in scope.row.contractInformationOfOld" :key="index">
                {{item.salesName?item.salesName:'--'}}
              </div>
            </template>
            </template>
          </el-table-column> -->
          <el-table-column label="老用户奖励金额">
            <template slot-scope="scope">
               <template v-if="scope.row.extendInformation.userType==='OLD'">
              {{scope.row.oldCustomer&&scope.row.oldCustomer.reward_money}}
               </template>
               <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="老用户奖励优惠券">
            <template slot-scope="scope">
               <template v-if="scope.row.extendInformation.userType==='OLD'">
              {{scope.row.oldCustomer&&scope.row.oldCustomer.couponTotalAmount}}
               </template>
               <template v-else>--</template>
            </template>
          </el-table-column>
          <!-- <el-table-column label="催费次数" :key="Math.random()">
            <template slot-scope="scope">
              <template v-if="scope.row.extendInformation&&scope.row.extendInformation.userType==='NEW'">
                --
              </template>
              <template v-else>
              {{scope.row.extendInformation&&(scope.row.extendInformation.remindPayNumber?scope.row.extendInformation.remindPayNumber:'--')}}
              </template>
            </template>
          </el-table-column> -->
          <el-table-column label="新用户手机号" min-width="120">
             <template slot-scope="scope">
               <router-link v-if="scope.row.extendInformation&&scope.row.extendInformation.customerBringNew&&
              scope.row.extendInformation.customerBringNew.newCustomer&&scope.row.extendInformation.customerBringNew.newCustomer.userMobile"
              :class="$style['get-customer-detail']" :to="`/all-customer/customer-detail/${scope.row.extendInformation.customerBringNew.newCustomer.userId}?state=basic-message`">
               {{scope.row.extendInformation.customerBringNew.newCustomer.userMobile}}
               </router-link>
               <template v-else>--</template>
            </template>
          </el-table-column>

          <el-table-column label="新用户CPS合同姓名">
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfNew&&scope.row.contractInformationOfNew.length">
              <div v-for="(item,index) in scope.row.contractInformationOfNew" :key="index">
                <template>{{item.motherName?item.motherName:'--'}}</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="新用户CPS合同号" min-width="180">
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfNew&&scope.row.contractInformationOfNew.length">
              <div v-for="(item,index) in scope.row.contractInformationOfNew" :key="index">
                <template>{{item.contractCode?item.contractCode:"--"}}</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="新用户CPS合同地区">
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfNew&&scope.row.contractInformationOfNew.length">
              <div v-for="(item,index) in scope.row.contractInformationOfNew" :key="index">
                <template>{{item.cpsRegion?item.cpsRegion:"--"}}</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>

          <el-table-column label="新用户CPS产品名称" min-width="180">
            <template slot-scope="scope">
              <template v-if="scope.row.contractInformationOfNew&&scope.row.contractInformationOfNew.length">
              <div v-for="(item,index) in scope.row.contractInformationOfNew" :key="index"   :class="index+1<scope.row.contractInformationOfNew.length?'production-name-code-buttom':null">
                <template v-if="item.productInformation.length">
                  <div v-for="(etem,i) in item.productInformation" :key="i">
                    {{etem.name?etem.name:"--"}}
                  </div>
                </template>
                <template v-else>--</template>
              </div>
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="新用户CPS业务员">
            <template slot-scope="scope">
            <template v-if="scope.row.contractInformationOfNew&&scope.row.contractInformationOfNew.length">
              <div v-for="(item,index) in scope.row.contractInformationOfNew" :key="index">
                {{item.salesName?item.salesName:'--'}}
              </div>
            </template>
            </template>
          </el-table-column>
          <el-table-column label="母亲姓名">
            <template slot-scope="scope">
              {{scope.row.genericFormData&&scope.row.genericFormData.data&&scope.row.genericFormData.data.name}}
            </template>
          </el-table-column>
          <el-table-column label="母亲身份证号" min-width="180">
            <template slot-scope="scope">
              {{scope.row.genericFormData&&scope.row.genericFormData.data&&scope.row.genericFormData.data.certificateNumber}}
            </template>
          </el-table-column>
          <el-table-column label="销售订单号" min-width="185">
            <template slot-scope="scope">
              <router-link v-if="scope.row.mallOrderNumber" :class="$style['get-customer-detail']" :to ="`/mall-order-all/order-detail/${scope.row.mallOrderId}/detail`">
                {{scope.row.mallOrderNumber}}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column label="是否有报告">
            <template slot-scope="scope">
              {{scope.row.extendInformation.hasReport?"有":"无"}}
            </template>
          </el-table-column>
          <el-table-column label="常住地区" min-width="150">
              <template slot-scope="scope">
                <template v-if="scope.row.newCustomer&&scope.row.newCustomer.region">
                  {{scope.row.newCustomer.region.provinceName+scope.row.newCustomer.region.cityName+
                  scope.row.newCustomer.region.districtName}}
                </template>
                <template v-else>--</template>
              </template>
          </el-table-column>

          <el-table-column label="新用户奖励金额">
            <template slot-scope="scope">
              <template v-if="scope.row.extendInformation.userType==='NEW'">
              {{scope.row.newCustomer&&scope.row.newCustomer.reward_money}}
              </template>
              <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="新用户奖励优惠券">
            <template slot-scope="scope">
               <template v-if="scope.row.extendInformation.userType==='NEW'">
              {{scope.row.newCustomer&&scope.row.newCustomer.couponTotalAmount}}
               </template>
               <template v-else>--</template>
            </template>
          </el-table-column>
          <el-table-column label="奖励轮次">
            <template slot-scope="scope">
              {{scope.row.extendInformation&&scope.row.extendInformation.customerBringNew&&scope.row.extendInformation.customerBringNew.finalRewardCount}}
            </template>
          </el-table-column>
        </template>
          <template>
            <slot/>
          </template>
        </wt-table>
         <div v-if="customerStatisticsData" class="table-tip-text-class">
      当前页面老用户奖励金额小计：<span class="amount-class">{{customerStatisticsData.oldCustomerOfMoney}}元</span>；
      新用户奖励金额小计：<span class="amount-class">{{customerStatisticsData.newCustomerOfMoney}}元</span>；
      总计：<span class="amount-class">{{customerStatisticsData.allCustomerOfMoney}}</span>元
      </div>
      </template>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-award-audit-table'

export default {
  name: 'pt-award-audit-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    businessType: {
      type: String
    },
    isShowSelect: {
      type: Boolean,
      default: false
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    customerStatisticsData: {
      type: Object
    }
  },
  methods: {
    clearSelection () {
      this.$refs.tables.clearSelection()
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    select (selection, row) {
      this.$emit('select', selection, row)
    },
    selectAll (rows) {
      this.$emit('selectAll', rows)
    },
    getTableData (page, next, size) {
      this.$emit('getTableData', page, next, size)
    }
  }
}
</script>
<style module lang="less">

.pt-award-audit-table{
:global{
  .el-table{
      border-top: 1px solid #edbe81;
      border-bottom: 1px solid #edbe81
    }
}
}
.table-tip-text{
  color: #909399;
  text-align: right;
  margin: 10px 0;
  :global{
    .amount-class{
      color: #edbe81
    }
  }
}
.get-customer-detail{
  color: #edbe81;
}
</style>
<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.production-name-code-buttom{
  border-bottom:1px solid #000
}
</style>
